module.exports = __webpack_public_path__ + "static/media/cynthia.e046a824.png";